import throttle from 'lodash/throttle';

export const tableSearchFetch =
    throttle((searchValue: string, func: (searchValue: string) => void) => {
        func(searchValue);
    }, 800);
